import compact from 'lodash/compact';
import isEmpty from 'lodash/isEmpty';

import { IconsEnum } from '../../../../assets/icons/types';
import { ClassName, I18nText } from '../../../../types';
import {
  FetchInvoicesCacheKeys,
  InvoiceID
} from '../../../invoices/invoicesTypes';
import { AvBillingInfoHelperItem } from './AvBillingInfoHelper.types';

import { InvoiceUpdateAvInvoiceBillingInfoContactEmailModalButton } from '../../../invoices/components/modalButtons/InvoiceUpdateAvInvoiceBillingInfoContactEmailModalButton';

import { Icon } from '../../../../helpers/Icon';
import { Translate } from '../../../../helpers/Translate';

import { formsFields, words } from '../../../../locales/keys';

interface AvBillingInfoHelperProps {
  className?: ClassName;
  avBillingInfo: AvBillingInfoHelperItem;
  i18nLabel?: I18nText;
  i18nWarning?: I18nText;
  invoiceId?: InvoiceID;
  cacheKeys?: FetchInvoicesCacheKeys;
  canUpdateContactEmail?: boolean;
}
function AvBillingInfoHelper({
  className,
  avBillingInfo,
  i18nWarning,
  i18nLabel,
  invoiceId,
  cacheKeys,
  canUpdateContactEmail
}: AvBillingInfoHelperProps) {
  const addressInfo = compact([
    avBillingInfo?.city,
    avBillingInfo?.state,
    avBillingInfo?.zipCode,
    avBillingInfo?.country
  ]).join(', ');

  return (
    <>
      {i18nLabel && (
        <div className="font-semibold">
          <Translate id={i18nLabel} />
        </div>
      )}

      {i18nWarning && isEmpty(avBillingInfo) && (
        <div className="text-red-500">
          <Icon
            icon={IconsEnum.EXCLAMATION_CIRCLE}
            className="h-4 w-4 -mt-0.5 mr-1 inline-block"
          />
          <Translate id={i18nWarning} />
        </div>
      )}

      {!isEmpty(avBillingInfo) && (
        <div className={className || 'text-gray-600 dark:text-gray-400'}>
          <div>{avBillingInfo.companyName}</div>
          {avBillingInfo.vatNumber && (
            <div>
              <Translate id={formsFields.vatNumber} />:{' '}
              {avBillingInfo.vatNumber}
            </div>
          )}
          <div>{avBillingInfo.address}</div>
          <div>{addressInfo}</div>
          <div className="flex group">
            <div className="relative">
              {avBillingInfo.contactEmail}
              {canUpdateContactEmail && invoiceId && (
                <span className="ml-2 inline sm:hidden sm:group-hover:inline sm:group-focus-within:inline">
                  <InvoiceUpdateAvInvoiceBillingInfoContactEmailModalButton
                    className="absolute top-1/2 -translate-y-1/2 z-5 py-0.5 pl-0.5 pr-0.5 rounded items-center whitespace-nowrap text-gray-500 dark:text-gray-300 border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700"
                    invoiceId={invoiceId}
                    contactEmail={avBillingInfo.contactEmail}
                    cacheKeys={cacheKeys}
                    icon={IconsEnum.PENCIL}
                    iconClassName="w-4 h-4"
                    tooltipI18nText={words.edit}
                  />
                </span>
              )}
            </div>
          </div>
          <div>{avBillingInfo.contactPhone}</div>
          <div className="h-2" aria-hidden="true" />
          <div className="whitespace-pre-wrap">{avBillingInfo.bankDetails}</div>
        </div>
      )}
    </>
  );
}

export default AvBillingInfoHelper;
